import { render } from "./PushCenter.vue?vue&type=template&id=73d47cb3&scoped=true"
import script from "./PushCenter.vue?vue&type=script&lang=js"
export * from "./PushCenter.vue?vue&type=script&lang=js"

import "./PushCenter.vue?vue&type=style&index=0&id=73d47cb3&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d47cb3"]])

export default __exports__